import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BoostIllustration from '../BoostIllustration';
const AlreadyBoostedModal = ({ onRequestClose })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: true,
        variant: "vertical",
        image: /*#__PURE__*/ React.createElement(BoostIllustration, null),
        onRequestClose: onRequestClose,
        title: t('boostDeviation.alreadyBoostedModal.title'),
        message: t('boostDeviation.alreadyBoostedModal.message'),
        footerButtons: [
            /*#__PURE__*/ React.createElement(ConfirmButton, {
                key: "confirm",
                onClick: onRequestClose
            }, t('common.gotIt'))
        ]
    });
};
AlreadyBoostedModal.displayName = 'AlreadyBoostedModal';
export default AlreadyBoostedModal;

//# sourceMappingURL=AlreadyBoostedModal.js.map